
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cupons/promobit",
      function () {
        return require("private-next-pages/cupons/promobit.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cupons/promobit"])
      });
    }
  